export default __webpack_public_path__ + "static/media/15.f188a707.png";